<script setup lang="ts">
const el = ref()
const v = useElementVisibility(el)
</script>

<template>
  <div ref="el" relative h-930px w-full lg:h-496px>
    <img absolute inset-0 max-h-496px object-cover class="zoom" size-full src="/images/group-100000271621.webp">

    <svg :class="v && 'animated-fade-in-left'" absolute animated class="left-[clamp(-10000px,calc((100vw-1920px)/2.5+0px),0px)]" xmlns="http://www.w3.org/2000/svg" width="1052" height="496" viewBox="0 0 1052 496" fill="none">
      <path d="M0 496H1052L709.5 0H0V496Z" fill="black" />
    </svg>

    <svg :class="v && 'animated-fade-in-right'" absolute animated class="right-[clamp(-10000px,calc((100vw-1920px)/1.5+0px),0px)]" xmlns="http://www.w3.org/2000/svg" width="663" height="496" viewBox="0 0 663 496" fill="none">
      <path d="M663 0H0L342.5 496H663V0Z" fill="black" />
    </svg>

    <div lt-lg="flex flex-col-reverse" absolute inset-0 container items-center lg:row lg:justify-end>
      <img :class="v && 'animated-fade-in-up'" class="scale-0" src="/images/group-1000002736-prod.webp" w-353px animated lg:mt--230px lt-lg:mt-20px>

      <div lg:ml-12 lt-lg:max-w-330px>
        <p class="text-35px font-bold lh-100% lg:text-80px" :class="v && 'animated-fade-in-right'" animated animated-delay-200>
          VOTE ROMA
        </p>
        <p :class="v && 'animated-fade-in-right'" mt-20px text-24px font-bold animated animated-delay-300 lg:text-53px>
          STEP 4
        </p>
        <p :class="v && 'animated-fade-in-right'" fond-bold text-15px animated animated-delay-400 lg:text-24px>
          Elect from over 1,000 cryptocurrencies to nominate a token you believe best represents your chosen ambassador.
        </p>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
@keyframes zoom {
  from {
    object-position: 25% center;
  }
  to {
    object-position: 100% center;
  }
}

img.zoom {
  animation: zoom ease-in-out 12s alternate infinite;
}
</style>
